import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CtaButton } from './CtaButton';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function OfferSection() {
  return <SectionWrapper id="offer" className="bg-brand-sand" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <div className="bg-white rounded-3xl shadow-xl border-2 border-brand-amber/30 overflow-hidden" data-id="element-107">
          <div className="bg-brand-terracotta text-white text-center py-4 px-6" data-id="element-108">
            <h2 className="font-serif text-2xl md:text-3xl font-bold" data-id="element-109">
              Detén el incendio hormonal hoy mismo
            </h2>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-110">
            <p className="font-sans text-xl md:text-2xl text-brand-brown/90 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-111">
              Recupera tu sueño, tu metabolismo y tu claridad mental por menos
              de lo que cuesta una cena fuera de casa. Accede al sistema
              completo "Menopausia Sin Tabú".
            </p>

            <div className="flex flex-col items-center justify-center mb-10" data-id="element-112">
              <span className="text-brand-brown/50 line-through text-2xl mb-2 font-serif" data-id="element-113">
                Valor Normal: $59.00 USD
              </span>
              <div className="flex items-baseline space-x-2" data-id="element-114">
                <span className="font-serif text-2xl text-brand-brown" data-id="element-115">
                  Inversión única:
                </span>
                <span className="font-serif text-5xl md:text-6xl font-bold text-brand-terracotta" data-id="element-116">
                  $6.39
                </span>
                <span className="font-serif text-xl text-brand-terracotta" data-id="element-117">
                  USD
                </span>
              </div>
            </div>

            <CtaButton className="mb-6 text-xl py-5" data-id="element-118">
              ¡QUIERO EMPEZAR MI PROTOCOLO DE 7 DÍAS YA!
            </CtaButton>

            <div className="flex flex-col sm:flex-row items-center justify-center space-y-3 sm:space-y-0 sm:space-x-6 text-brand-brown/70 font-sans text-sm" data-id="element-119">
              <div className="flex items-center" data-id="element-120">
                <ShieldCheckIcon className="w-5 h-5 mr-2 text-brand-sage" data-id="element-121" />
                <span data-id="element-122">Acceso inmediato tras el pago.</span>
              </div>
              <div className="flex items-center" data-id="element-123">
                <LockIcon className="w-5 h-5 mr-2 text-brand-sage" data-id="element-124" />
                <span data-id="element-125">Pago seguro y cifrado.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}